import RaisedPanel from './raised-panel';

export default RaisedPanel;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/RaisedPanel/index.js